<script setup>
  import { Plus } from "lucide-vue-next";
  import { ref } from "vue";
  import { storeToRefs } from "pinia";
  import { Button } from "@/components/ui/button";
  import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
  import { useMMediumUploadsStore } from "@stores/mMediumUploads";

  const props = defineProps({
    videoType: {
      type: String,
      required: true,
    },
  });

  const isOpen = ref(true);
  const fileInputRef = ref(null);

  const mMediumUploadsStore = useMMediumUploadsStore();
  const { storyVideos, activeStoryVideos, feedVideos, activeFeedVideos } = storeToRefs(mMediumUploadsStore);
  const { toggleMMediumUpload, isMMediumUploadSelected, addMMediumUpload } = mMediumUploadsStore;

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const placement = props.videoType === "feed" ? "feed" : "story";
    const medium = await addMMediumUpload(file, "video", placement);
    toggleMMediumUpload(medium, true);
    event.target.value = "";
  };
</script>

<template>
  <div>
    <Collapsible
      :open="isOpen"
      @update:open="isOpen = $event">
      <CollapsibleTrigger class="flex w-full items-center justify-between py-2 text-sm font-medium">
        {{ videoType === "feed" ? "Feed" : "Story" }}
      </CollapsibleTrigger>
      <CollapsibleContent>
        <label>
          <input
            ref="fileInputRef"
            type="file"
            accept="video/*"
            class="hidden"
            @change="handleFileChange" />
          <Button
            size="sm"
            @click="fileInputRef?.click()">
            <Plus class="h-4 w-4 mr-1" />
            New upload
          </Button>
        </label>

        <ul class="mt-2 inline-flex flex-wrap gap-0 list-none p-0 m-0">
          <li
            v-for="(mMedium, index) in videoType === 'feed' ? feedVideos : storyVideos"
            :key="`creative-video-${index}`"
            class="mr-2 mb-2 inline-flex h-[136px] w-[136px] cursor-pointer overflow-hidden rounded-md border-2 bg-muted"
            :class="isMMediumUploadSelected(mMedium.id) ? 'border-primary' : 'border-border'"
            @click="toggleMMediumUpload(mMedium, (uniq = true))">
            <video
              class="block h-full w-full max-w-full object-contain"
              :src="mMedium.url"
              :alt="mMedium.name" />
          </li>
        </ul>
      </CollapsibleContent>
    </Collapsible>

    <div v-if="!isOpen">
      <ul class="inline-flex flex-wrap gap-0 list-none p-0 m-0">
        <li
          v-for="(mMedium, index) in videoType === 'feed' ? activeFeedVideos : activeStoryVideos"
          :key="`creative-video-${index}`"
          class="mr-2 mb-2 inline-flex h-[136px] w-[136px] overflow-hidden rounded-md border-2 border-primary bg-muted">
          <video
            class="block h-full w-full max-w-full object-contain"
            :src="mMedium.url"
            :alt="mMedium.name" />
        </li>
      </ul>
    </div>
  </div>
</template>
